import { CHAT_SURFACE } from '@/config/environment';
import { CentralChatFloatingBubble } from './CentralChatFloatingBubble';
import { CentralChatHeaderPanel } from './CentralChatHeaderPanel';
import { CentralChatRail } from './CentralChatRail';
import { chatSurfaceFor } from './railRoutes';

interface CentralChatSurfaceProps {
  pathname: string;
  /** Overrides the build-time VITE_CHAT_SURFACE value (tests). */
  surface?: unknown;
}

/**
 * The one place the app shell chooses how Emjae shows up: the header badger's side panel
 * (the default), the docked right-side rail, the floating bubble, or nothing (editor and /chat own their chrome). The rule
 * lives in `chatSurfaceFor`; this only mounts the answer.
 */
export function CentralChatSurface({ pathname, surface }: CentralChatSurfaceProps) {
  const which = chatSurfaceFor(pathname, surface ?? CHAT_SURFACE);
  if (which === 'rail') return <CentralChatRail />;
  if (which === 'bubble') return <CentralChatFloatingBubble pathname={pathname} />;
  // The badger itself lives in the top bar (the layout mounts CentralChatHeaderLauncher); this is its panel.
  if (which === 'header') return <CentralChatHeaderPanel />;
  return null;
}
